import styled from 'styled-components'

export const Title = styled.legend`
  font-family: ${({ theme }) => theme.fonts.brand};
  text-transform: uppercase;
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 0;
  margin: auto;
  padding: 0 2.5rem;
  color: ${({ theme }) => theme.colors.brandFrame};
  width: auto !important;
  border: none !important;
`

export const Border = styled.fieldset`
  color: ${({ theme }) => theme.colors.brandFrame};
  border: 1px solid ${({ theme }) => theme.colors.brandFrame};
  box-sizing: border-box;
  position: absolute;
  top: 0;
  margin: 1rem;
  width: calc(100% - 2rem);
  height: calc(100% - 2rem);
`
